import { ChangeDetectionStrategy, Component, OnInit, signal, inject } from '@angular/core';
import { ProfileService, StaticContentService } from '@mwe/services';
import { Router } from '@angular/router';
import { FeatureToggleEnum } from '@mwe/constants';
import { InteractiveInvoiceStaticData } from '@mwe/models';
import { IsFeatureEnabledDirective } from '../../directives/feature-toggles/is-feature-enabled.directive';
import { AlertComponent } from '../../alert/alert.component';

@Component({
  selector: 'mwe-interactive-invoice-alert',
  templateUrl: './interactive-invoice-alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IsFeatureEnabledDirective, AlertComponent],
})
export class InteractiveInvoiceAlertComponent implements OnInit {
  private staticContentService = inject(StaticContentService);
  private router = inject(Router);
  private profileService = inject(ProfileService);

  isAlertVisible = signal<boolean>(false);
  data = signal<InteractiveInvoiceStaticData>(undefined);
  featureToggleName = signal<FeatureToggleEnum>(FeatureToggleEnum.INVOICE_ALERT_ENABLED);

  async ngOnInit(): Promise<void> {
    if (this.profileService.isFeatureToggleDisabled(this.featureToggleName())) {
      return;
    }
    const data = await this.staticContentService.getInteractiveInvoiceStaticData();
    this.data.set(data);
    this.isAlertVisible.set(this.data()?.alert?.urls?.some(url => url === this.router.url));
  }
}
